import { roundToTwoDecimals } from './mathUtils';

//Calculates the weighted average of a list of grades.
export const calculateGradesAverage = (grades) => {
  if (!grades || grades.length === 0) {
    return null;
  }

  let totalWeightedScore = 0;
  let totalWeight = 0;

  grades.forEach((grade) => {
    const weight = parseFloat(grade.weight) || 1.0;
    const value = parseFloat(grade.gradeValue);

    if (!isNaN(value) && !isNaN(weight)) {
      totalWeightedScore += value * weight;
      totalWeight += weight;
    }
  });

  if (totalWeight === 0) {
    return null;
  }

  return roundToTwoDecimals(totalWeightedScore / totalWeight);
};

/**
 * Calculates the overall average by first calculating the weighted average for each subject,
 * and then taking the unweighted average of those subject averages.
 * This is the standard way to calculate GPA/Overall Grade in this system.
 */
export const calculateOverallAverage = (grades) => {
  if (!grades || grades.length === 0) return null;

  // Group grades by subject
  const subjectGrades = {};
  grades.forEach(grade => {
    const subjectId = grade.subjectId || grade.subject_id;
    if (subjectId) {
      if (!subjectGrades[subjectId]) {
        subjectGrades[subjectId] = [];
      }
      subjectGrades[subjectId].push(grade);
    }
  });

  // Calculate average for each subject
  const subjectAverages = [];
  Object.values(subjectGrades).forEach(grades => {
    const avg = calculateGradesAverage(grades);
    if (avg !== null) {
      subjectAverages.push(parseFloat(avg));
    }
  });

  if (subjectAverages.length === 0) return null;

  // Calculate average of subject averages
  const total = subjectAverages.reduce((sum, avg) => sum + avg, 0);
  return roundToTwoDecimals(total / subjectAverages.length);
};

export const calculateAverage = (grades, selectedSubjectIds, semester) => {
  if (!grades) return null;

  let filteredGrades = grades;

  // Filter by semester if provided and if grades have semester information
  if (semester) {
    const semesterName = typeof semester === 'object' ? semester.name : semester;
    const semesterId = typeof semester === 'object' ? semester.id : null;
    
    filteredGrades = filteredGrades.filter(grade => {
        // Check by ID first if available
        if (semesterId && (grade.semesterId === semesterId || grade.semester_id === semesterId)) {
          return true;
        }
        // Fallback to name check
        if (grade.semester) {
             return grade.semester === semesterName || grade.semester.name === semesterName;
        }
        return true; 
    });
  }

  // Filter by selected subjects
  if (selectedSubjectIds && selectedSubjectIds.length > 0) {
    filteredGrades = filteredGrades.filter(grade => selectedSubjectIds.includes(grade.subjectId));
  }

  // Use the consistent "Average of Subject Averages" method
  return calculateOverallAverage(filteredGrades);
};
